import { render, staticRenderFns } from "./ImportExpedientsSummaryComponent.vue?vue&type=template&id=0080fc56&scoped=true"
import script from "./ImportExpedientsSummaryComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportExpedientsSummaryComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ImportExpedientsSummaryComponent.vue?vue&type=style&index=0&id=0080fc56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080fc56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0080fc56')) {
      api.createRecord('0080fc56', component.options)
    } else {
      api.reload('0080fc56', component.options)
    }
    module.hot.accept("./ImportExpedientsSummaryComponent.vue?vue&type=template&id=0080fc56&scoped=true", function () {
      api.rerender('0080fc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsSummaryComponent.vue"
export default component.exports